import React from 'react';
import R from 'ramda';
import Heading from '@cotyorg/ccx-atoms/Heading';
import PropTypes from 'prop-types';
import SearchResultItem from '../SearchResultItem';

export const getTitle = ({ hasResults, hasHistory, searchTitles = {} } = {}) => {
  const { resultsTitle, recentSearchesTitle, popularSearchesTitle } = searchTitles;

  if (hasResults) {
    return resultsTitle;
  } else if (hasHistory) {
    return recentSearchesTitle;
  }

  return popularSearchesTitle;
};

export const getResults = ({
  hasResults,
  hasHistory,
  results,
  searchTermHistory,
  popularSearches,
} = {}) => {
  if (hasResults) {
    return results;
  } else if (hasHistory) {
    return searchTermHistory;
  }
  return popularSearches;
};

// istanbul ignore next
const SearchResults = ({
  term,
  results,
  searchTermHistory,
  searchTitles,
  popularSearches,
  fetchSearchResults,
  clearSearchHistory,
  clearSearchTermHistoryButtonText,
  searchURL,
  locale,
  presentationLocale,
  isServedFromLegacySite,
}) => {
  const hasResults = results && !!results.length;
  const hasHistory = searchTermHistory && !!searchTermHistory.length;

  return (
    <div className="search__results">
      <Heading extraClass="search__results-title" level={6}>
        { getTitle({ hasResults, hasHistory, searchTitles }) }
      </Heading>
      <ul className="search__results-list" >
        {
          getResults({
            hasResults,
            hasHistory,
            results,
            searchTermHistory,
            popularSearches,
          }).map(({
            title,
            uid,
            product_subcategory: productSubcategory,
            slug,
            legacy_url: legacyURL,
          }) => (
            <SearchResultItem
              key={uid}
              title={title}
              term={term}
              hasResults={hasResults}
              fetchSearchResults={fetchSearchResults}
              searchURL={searchURL}
              locale={locale}
              presentationLocale={presentationLocale}
              category={
                R.compose(
                  R.replace(/^\//, ''),
                  R.pathOr('', ['0', 'category', '0', 'url']),
                )(productSubcategory)
              }
              subcategory={
                R.compose(
                  R.replace(/^\//, ''),
                  R.pathOr('', ['0', 'url']),
                )(productSubcategory)
              }
              slug={slug}
              legacyURL={legacyURL}
              isServedFromLegacySite={isServedFromLegacySite}
            />
          ))
        }
      </ul>
      {
        !hasResults && hasHistory && (
          <button onClick={clearSearchHistory} className="button button--clear search__results-clear-button">
            {clearSearchTermHistoryButtonText}
          </button>
        )
      }
    </div>
  );
};

SearchResults.propTypes = {
  results: PropTypes.arrayOf(PropTypes.object),
  term: PropTypes.string.isRequired,
  searchTermHistory: PropTypes.arrayOf(PropTypes.object),
  searchTitles: PropTypes.shape({
    resultsTitle: PropTypes.string.isRequired,
    recentSearchesTitle: PropTypes.string.isRequired,
    popularSearchesTitle: PropTypes.string.isRequired,
  }).isRequired,
  popularSearches: PropTypes.arrayOf(PropTypes.object).isRequired,
  fetchSearchResults: PropTypes.func.isRequired,
  clearSearchHistory: PropTypes.func.isRequired,
  clearSearchTermHistoryButtonText: PropTypes.string.isRequired,
  searchURL: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  presentationLocale: PropTypes.string.isRequired,
  isServedFromLegacySite: PropTypes.bool,
};

export default SearchResults;
